document.addEventListener('DOMContentLoaded', function() {
  const root = document.getElementById('pchef-dynamic-root');
  if (!root) return;

  const config = JSON.parse(root.dataset.config || "[]");
  const feeVariantId = "44811906220102"; 
  let state = {};

  function render() {
    root.innerHTML = '';
    
    // 🔥 SİPARİŞE YAZDIRMA MANTIĞI: Seçilenleri Shopify'ın okuyacağı gizli inputlara aktarır
    Object.keys(state).forEach(key => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${key}]`; // Siparişte başlık olarak görünür (örn: Seçilen Parfümler)
      input.value = Array.isArray(state[key]) ? state[key].join(', ') : state[key];
      root.appendChild(input);
    });

    config.forEach(opt => {
      // Hacim/ML seçeneği artık gerçek Shopify varyantı olarak yönetiliyor; özel seçeneği atla
      var _lbl = (opt.label || '').toLowerCase();
      if (_lbl.indexOf('hacim') !== -1 || _lbl.indexOf(' ml') !== -1 || _lbl === 'ml') {
        delete state[opt.id];
        return;
      }

      // CASE KONTROLÜ (Logic)
      if (opt.logic) {
        const [key, op, val] = opt.logic.split(' ');
        if (state[key] !== val) { 
          delete state[opt.id]; 
          return; 
        }
      }

      const div = document.createElement('div');
      div.className = 'pchef-row';
      div.innerHTML = `<label class="pchef-label">${opt.label}</label>`;

      // TESTER LISTESİ VE ARAMA
      if (opt.type === 'tester_list') {
        const container = document.createElement('div');
        container.style.position = 'relative';
        if(!state[opt.id]) state[opt.id] = [];

        const listDiv = document.createElement('div');
        listDiv.className = 'selected-testers-list';
        state[opt.id].forEach((item, index) => {
          const sItem = document.createElement('div');
          sItem.className = 'selected-tester-item';
          sItem.innerHTML = `<span>${index + 1}. ${item}</span> <span class="remove-tester" style="cursor:pointer; color:red; font-weight:bold; padding-left:10px;" data-index="${index}">✕</span>`;
          sItem.querySelector('.remove-tester').onclick = (e) => { 
            e.stopPropagation();
            state[opt.id].splice(index, 1); 
            render(); 
          };
          listDiv.appendChild(sItem);
        });

        const searchInput = document.createElement('input');
        searchInput.type = 'text';
        searchInput.placeholder = 'Parfüm veya Marka Ara...';
        searchInput.className = 'pchef-input-text';
        searchInput.autocomplete = 'off';
        
        const resultsDiv = document.createElement('div');
        resultsDiv.className = 'pchef-search-results';
        resultsDiv.style.display = 'none';

        searchInput.oninput = async (e) => {
          const term = e.target.value.trim().toLowerCase();
          if(term.length < 2) { resultsDiv.style.display = 'none'; return; }

          try {
            const resp = await fetch(`/search?q=${encodeURIComponent(term)}&type=product&view=json`);
            const data = await resp.json();
            
            resultsDiv.innerHTML = '';
            if(data && data.length > 0) {
              // Shopify site aramasının sonuçlarına birebir güveniyoruz (etiket/metafield
              // eşleşmeleri dahil). Ekstra başlık filtresi koyma — muadil isimli ürünler
              // orijinal adıyla aratıldığında da çıksın.
              data.forEach(p => {
                if(p.title.includes('Tester Paketi')) return;
                if(/chef['’`´]?s/i.test(p.title)) return; // Chef's ürünleri tester paketinde seçilemez

                const item = document.createElement('div');
                item.className = 'search-result-item';
                item.innerHTML = `<strong>${p.title}</strong>`;

                item.onclick = () => {
                  if(state[opt.id].length < 5) {
                    state[opt.id].push(p.title);
                    searchInput.value = '';
                    resultsDiv.style.display = 'none';
                    render();
                  } else { alert("Maksimum 5 adet seçebilirsiniz."); }
                };
                resultsDiv.appendChild(item);
              });
            }
            resultsDiv.style.display = resultsDiv.children.length > 0 ? 'block' : 'none';
          } catch (err) {
            console.error("Arama hatası:", err);
          }
        };

        container.appendChild(listDiv);
        if(state[opt.id].length < 5) { 
          container.appendChild(searchInput); 
          container.appendChild(resultsDiv); 
        }
        div.appendChild(container);
      } 
      
      // RADYO BUTONLARI
// RADYO BUTONLARI (Seçenekler)
else if (opt.type === 'radio') {
  const group = document.createElement('div');
  group.className = 'pchef-radio-group';
  
  opt.options.forEach(o => {
    const val = typeof o === 'object' ? o.val : o;
    
    // 🔥 DEFAULT SEÇİM MANTIĞI
    // Eğer state boşsa ve değer 'Hayır' veya '50 ML' ise default seç
    if (!state[opt.id]) {
        if (val === 'Hayır' || val === '50 ML') {
            state[opt.id] = val;
        }
    }

    const lbl = document.createElement('label');
    const isChecked = state[opt.id] === val ? 'checked' : '';
    
    lbl.innerHTML = `
      <input type="radio" 
             name="properties[${opt.label}]" 
             value="${val}" 
             ${isChecked}> 
      ${val}`;
    
    lbl.querySelector('input').onchange = () => { 
      state[opt.id] = val; 
      render(); 
    };
    group.appendChild(lbl);
  });
  div.appendChild(group);
}
      
      // METİN ALANI
else if (opt.type === 'text') {
  const input = document.createElement('input');
  input.type = 'text';
  input.placeholder = opt.placeholder || opt.label;
  input.className = 'pchef-input-text';
  
  // 🔥 KRİTİK SATIR: Bu isim olmazsa sepete düşmez
  input.name = `properties[${opt.label}]`; 
  
  input.value = state[opt.id] || '';
  
  // Kullanıcı yazdıkça state'i güncelle
  input.oninput = (e) => { 
    state[opt.id] = e.target.value;
    // Eğer butonu kilitleme fonksiyonumuz varsa burada çağırıyoruz
    if (typeof updateAddToCartButton === "function") updateAddToCartButton();
  };
  
  div.appendChild(input);
}
      root.appendChild(div);
    });
  }

// --- ŞIK UYARI FONKSİYONU ---
function showModernAlert(message) {
  let alertBox = document.getElementById('pchef-custom-alert');
  if (!alertBox) {
    alertBox = document.createElement('div');
    alertBox.id = 'pchef-custom-alert';
    Object.assign(alertBox.style, {
      position: 'fixed',
      bottom: '30px',
      left: '50%',
      transform: 'translateX(-50%)',
      backgroundColor: '#333',
      color: 'white',
      padding: '12px 24px',
      borderRadius: '50px',
      boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
      zIndex: '100000', // En üstte kalması için çok yüksek tutalım
      fontFamily: 'inherit',
      fontSize: '14px',
      transition: 'all 0.4s ease',
      opacity: '0',
      pointerEvents: 'none'
    });
    document.body.appendChild(alertBox);
  }
  alertBox.innerText = message;
  alertBox.style.opacity = '1';
  alertBox.style.bottom = '50px';
  setTimeout(() => { 
    alertBox.style.opacity = '0'; 
    alertBox.style.bottom = '30px';
  }, 3500);
}

function validatePChefForm(e) {
  let isInvalid = false;
  let errorMsg = "";

  // Tester paketi tespiti: varyant ID'ye güvenme, sayfada seçim listesi render edilmiş mi diye bak.
  // Seçilen parfümleri de doğrudan ekrandaki listeden say — arama kutusuna yazılan metin sayılmaz.
  const testerList = document.querySelector('.selected-testers-list');
  if (testerList) {
    const selectedCount = document.querySelectorAll('.selected-tester-item').length;

    if (selectedCount < 5) {
      isInvalid = true;
      errorMsg = "Lütfen paketiniz için 5 adet parfüm seçin. Şu an: " + selectedCount;
    }
  } else {
    // Diğer ürünler için zorunlu metin kutularını kontrol et.
    // Arama kutusunun name'i olmadığı için [name] filtresiyle otomatik hariç kalır.
    const textInputs = document.querySelectorAll('.pchef-input-text[name]');
    textInputs.forEach(input => {
      if (!input.value.trim()) {
        isInvalid = true;
        errorMsg = "Lütfen zorunlu alanları doldurun.";
        input.style.border = '2px solid #ff4b4b';
      } else {
        input.style.border = '1px solid #ccc';
      }
    });
  }

  if (isInvalid) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    showModernAlert(errorMsg);
    
    // 🔥 ANİMASYONU SIFIRLA: Butonun üzerindeki temanın eklediği sınıfları temizle
    const btn = e.target.closest('[name="add"], .product-form__submit') || document.querySelector('[name="add"]');
    if (btn) {
       btn.classList.remove('loading', 'is-loading', 'working', 'added');
       btn.removeAttribute('aria-disabled');
       // Bazı temalarda butonun içindeki span değişir, onu da resetleyelim
       const btnText = btn.querySelector('.button-text') || btn;
       if(btnText.innerText.includes('✓')) btnText.innerText = "Sepete Ekle";
    }
    
    return false;
  }
  return true;
}

// OLAYLARI YAKALA (CAPTURE MODE)
document.addEventListener('submit', validatePChefForm, { capture: true });
document.addEventListener('click', function(e) {
  if (e.target.closest('[name="add"], .product-form__submit')) {
    validatePChefForm(e);
  }
}, { capture: true });

// 3. HEMEN SATIN AL İÇİN (Buton Tıklaması)
document.addEventListener('click', function(e) {
  // Shopify'ın o meşhur "Hemen Satın Al" butonunu havada yakalıyoruz
  const checkoutBtn = e.target.closest('.shopify-payment-button__button, .shopify-payment-button [role="button"]');
  
  if (checkoutBtn) {
    // Aynı fonksiyonu burada da çalıştırıyoruz, ayrı metod yok!
    validatePChefForm(e);
  }
}, { capture: true });

function manageCheckoutButton() {
  // Hemen Satın Al butonunu içeren kapsayıcıyı bul (Genelde sınıfı budur)
  const dynamicCheckout = document.querySelector('.shopify-payment-button');
  if (!dynamicCheckout) return;

  // Seçimlerin tamam olup olmadığını kontrol et
  const urlParams = new URLSearchParams(window.location.search);
  const currentVariantId = urlParams.get('variant') || document.querySelector('[name="id"]')?.value;
  const targetVariantId = "44888785911878";

  let isMissing = false;
  if (currentVariantId === targetVariantId) {
    if ((state['tester_list'] || []).length < 5) isMissing = true;
  } else {
    const textInputs = document.querySelectorAll('.pchef-input-text');
    textInputs.forEach(input => { if (!input.value.trim()) isMissing = true; });
  }

  // 🔥 ENGEL KOYMA MANTIĞI
  if (isMissing) {
    dynamicCheckout.style.pointerEvents = "none"; // Tıklamayı tamamen iptal et
    dynamicCheckout.style.opacity = "0.6";         // Görsel olarak pasif yap
    dynamicCheckout.style.filter = "grayscale(1)"; // Daha net bir "pasif" görüntüsü
  } else {
    dynamicCheckout.style.pointerEvents = "auto";
    dynamicCheckout.style.opacity = "1";
    dynamicCheckout.style.filter = "none";
  }
}



  render(); 
});

